import type { IIntentItem } from 'src/types/file';

import React, { useMemo, useState, createContext } from 'react';

type FilesContextState = {
  allFiles: IIntentItem[];
  files: IIntentItem[];
  setFiles: React.Dispatch<React.SetStateAction<IIntentItem[]>>;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  totalCount: number;
  setTotalCount: React.Dispatch<React.SetStateAction<number>>;
};

export const FilesContext = createContext<FilesContextState | undefined>(undefined);

const FilesProvider = ({ children }: { children: React.ReactNode }) => {
  const [files, setFiles] = useState<IIntentItem[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalCount, setTotalCount] = useState(0);

  const filterFiles = useMemo(
    () => files.filter((file) => file.audioFileName.toLowerCase().includes(searchTerm.toLowerCase())),
    [searchTerm, files]
  );

  const values = useMemo(
    () => ({
      allFiles: files,
      files: filterFiles,
      setFiles,
      searchTerm,
      setSearchTerm,
      totalCount,
      setTotalCount,
    }),
    [files, searchTerm, filterFiles, totalCount]
  );

  return <FilesContext.Provider value={values}>{children}</FilesContext.Provider>;
};

export default FilesProvider;
